module.exports = __webpack_public_path__ + "img/twitter.30ad70f9.svg";